import { ETechnicalSignature } from "common/enums/ProductSheet/ETechnicalSignature";
import { ESubscriptionProductType } from "common/enums/ProductSubscribed/ESubscriptionProductType";
import ProductSubscribedResponseResource from "common/resources/ProductSubscribed/ProductSubscribedResponseResource";

export function isProductEligibleForElectronicSignature(product: ProductSubscribedResponseResource): boolean {
	return (
		product.productSheet?.technicalSignatureType === ETechnicalSignature.auto &&
		product.subscriptionProductType !== ESubscriptionProductType.nue_propriete &&
		product.subscriptionProductType !== ESubscriptionProductType.usufruit
	);
}
